import React from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Button, Col, Row, Radio, Modal, Tooltip, message } from 'antd';
import dayjs from 'dayjs';
import Map from '../MapOld';
import { Link } from 'react-router-dom';
import { isEmpty } from 'underscore';
import ReactToPdf from 'react-to-pdf';
import VideoSelection from './partial/VideoSelection';
import VideoPlayers from './partial/VideoPlayers';
import { timeToSeconds, convertFromSeconds } from '../../core/utils/functions';
import { requestMarkerDetails, setMarkerPopoverToLoading } from '../../core/utils/mapUtils';
import ExportVideoStatus from './partial/ExportVideoStatus';
import Spinner from '../Spinner';
import moment from 'moment';
import { getFormattedDatetime } from '../../core/utils/dateUtils';
import { CopyOutlined } from '@ant-design/icons';

import './detailView.scss';

const { GOOGLE_MAP_API_KEY, DEBUG } = require('../../core/constants').default;

const urlText = React.createRef();
const passwordText = React.createRef();

export default function () {
    const {
        selectedEvent, user, searchedSingleVideoChannels, isFetchingVideoUrls, allowActions,
        showStreamingSectionOnLoad, showDownloadIframe, parent, showTimingPresetsFooter,
        sidebarIsOpen, shareReportType, eventsIsFetching, actions,
    } = this.props;
    const {
        sliderValue, sliderRangeMinValue, sliderRangeMaxValue, streamingVideos, videoMode,
        showResetBtn, markerPopover, videoStreamsReady, exportedCacheVideo, shareModalIsOpen,
    } = this.state;

    const hasDVR = selectedEvent && selectedEvent.dvrDetails && Object.keys(selectedEvent.dvrDetails).length > 0;
    const mapWidthSpan = streamingVideos ? 10 : (!hasDVR && !showStreamingSectionOnLoad ? 24 : 10);
    const mappedDevicePath = this.mapDevicePath(selectedEvent);
    const assets = this.getAssetCurrentPin(mappedDevicePath);
    const disablePlayButton = !((videoMode === 'streaming' && videoStreamsReady) || videoMode !== 'streaming');
    //this is needed since the tooltip will override the original which switches between play / pause
    const playPauseButton = { key: 'play-pause', visible: true, disabled: disablePlayButton };
    if (disablePlayButton) {
        playPauseButton.tooltip = 'Video not ready or not selected';
    }
    const mapToolBarButtons = [
        { key: 'info-box', visible: true },
        { key: 'traffic', visible: false },
        { key: 'geo-fence', visible: false },
        { key: 'center-map', visible: false },
        { key: 'satellite', visible: true },
        { key: 'heat-map', visible: false },
        { key: 'live-map', visible: false },
        { key: 'video-search', visible: false },
        playPauseButton,
    ];
    const dvrOnline = selectedEvent?.dvrDetails?.is_online || 0;
    const cachedVideos = selectedEvent?.dvrDetails?.cached_videos || [];
    const discoveredVideos = Object.values(selectedEvent?.dvrDetails?.discovered_videos ?? {});
    const channels = selectedEvent?.dvrDetails?.available_channels || [];
    const hasFailedCached = selectedEvent?.dvrDetails?.has_failed_cache || false;
    const { permissions = {} } = user || {};
    const videoSidePanelPermission = permissions?.live_video || permissions?.historic_video_downloading || parent === 'sharedView';
    const highlightSlider = [];
    if (cachedVideos && cachedVideos.length > 0) {
        cachedVideos.forEach((cVideo) => {
            const startTimeParts = cVideo[0].start_time && (cVideo[0].start_time).split(' ');
            const endTimeParts = cVideo[0].end_time && (cVideo[0].end_time).split(' ');
            if (startTimeParts && startTimeParts[1] && endTimeParts && endTimeParts[1]) {
                let cacheVideoStart = timeToSeconds(startTimeParts[1]);
                let cacheVideoEnd = timeToSeconds(endTimeParts[1]);
                if (cacheVideoStart < selectedEvent?.endInterval) {
                    if (cacheVideoStart < selectedEvent?.startInterval) {
                        cacheVideoStart = selectedEvent?.startInterval;
                    }
                    if (cacheVideoEnd > selectedEvent?.endInterval) {
                        cacheVideoEnd = selectedEvent?.endInterval;
                    }
                    highlightSlider.push([cacheVideoStart, cacheVideoEnd]);
                }
            }
        });
    }
    const share = selectedEvent?.share;
    let isSharedAndValid = false;
    let isSharedAndExpired = false;
    const sharePort = DEBUG || window.location.hostname === 'localhost' ? `:${window.location.port}` : '';
    let shareLink = null;
    if (share && share.unique_code) {
        isSharedAndValid = true;
        shareLink = `${window.location.protocol}//${window.location.hostname}${sharePort}/event/${share.unique_code}`;
        if (share.expire == 0) {
            isSharedAndExpired = true;
        }
    }
    const generateEventReport = () => {
        if (!isSharedAndExpired && !isSharedAndValid) {
            actions.shareWebReportRequest({
                eventId: selectedEvent?.info?.event_id,
                deviceId: selectedEvent?.info?.device_id,
                before_time: selectedEvent?.startThreshold,
                after_time: selectedEvent?.endThreshold,
                sliderValue: selectedEvent?.sliderValue || selectedEvent?.startInterval,
                sliderRangeMinValue,
                sliderRangeMaxValue,
            });
        } else if (isSharedAndExpired) {
            actions.renewSharedReportRequest({
                eventId: selectedEvent?.info?.event_id,
                deviceId: selectedEvent?.info?.device_id,
                before_time: selectedEvent?.startThreshold,
                after_time: selectedEvent?.endThreshold,
                uniqueCode: selectedEvent?.share?.unique_code,
            });
        }
    };
    const generateVideoReport = () => {
        if (!isSharedAndExpired && !isSharedAndValid) {
            const end_time = getFormattedDatetime(moment(selectedEvent?.info?.record_time)
                .add(selectedEvent?.info?.duration, 'seconds'));
            const payload = {
                historicVideoId: selectedEvent?.info?.historic_video_id,
                deviceId: selectedEvent?.info?.device_id,
                start_time: selectedEvent?.info?.record_time,
                end_time,
                sliderValue: selectedEvent?.sliderValue || selectedEvent?.startInterval,
                sliderRangeMinValue,
                sliderRangeMaxValue,
            };
            actions.shareWebReportRequest(payload);
        }
    };
    const generateCacheReport = () => {
        if (!isSharedAndExpired && !isSharedAndValid) {
            const startTime = convertFromSeconds(selectedEvent?.info?.start_time);
            const startDateTime = `${selectedEvent?.info?.date} ${startTime}`;
            const endTime = convertFromSeconds(selectedEvent?.info?.end_time);
            const endDateTime = `${selectedEvent?.info?.date} ${endTime}`;
            const payload = {
                reference: selectedEvent?.reference,
                deviceId: selectedEvent?.info?.device_id,
                start_time: startDateTime,
                end_time: endDateTime,
                sliderValue: selectedEvent?.sliderValue || selectedEvent?.startInterval,
                sliderRangeMinValue,
                sliderRangeMaxValue,
            };
            actions.shareWebReportRequest(payload);
        }
    };
    const videoContent = () => {
        const { live_video: canViewLiveVideo, historic_video_downloading: canViewHistoricVideo } = permissions;

        if (canViewLiveVideo && videoMode === 'streaming') {
            if (hasFailedCached) {
                return (
                    <VideoSelection
                        parent={this}
                        title="The cache process failed"
                        content="Please click the below button to request cache again"
                        buttonLabel="Request Cache"
                        channels={[]}
                        onClick={this.requestCacheAgain} />
                );
            }

            return (
                <Spinner loading={isFetchingVideoUrls} minHeight={200}>
                    {/* Choose streaming channels (when device is online) */}
                    {((!streamingVideos && +dvrOnline === 1) || (searchedSingleVideoChannels.length === 0 && +dvrOnline === 1)) && channels.length > 0
                        ? (
                            <VideoSelection
                                parent={this}
                                title="Stream Videos"
                                content="Move the middle point on the event slider bar to the location/time you want to view, select channels below, then click 'view'"
                                buttonLabel="View"
                                channels={channels}
                                onClick={this.getSelectedVideosUrl} />
                        )
                        : null}

                    {/* If there are no channels, Show a message */}
                    {channels.length === 0
                        ? (
                            <div style={{
                                textAlign: 'center',
                                marginTop: '16px',
                            }}>No video channel available for this device. Please set up a channel to view or export video.</div>
                        )
                        : null}

                    {/* Streaming not available when device is not online */}
                    {!streamingVideos && +dvrOnline === 0 && channels.length > 0
                        ? (
                            <VideoSelection
                                allowActions={canViewHistoricVideo && allowActions}
                                className="extra-height"
                                title="Stream Unavailable"
                                parent={this}
                                content={(
                                    <>
                                        <div>We cannot connect to the asset to stream the video. This might be because the vehicle is offline, not connected to a power source, or
                                            has a weak signal.
                                        </div>
                                        <div>We can download this footage for you automatically when the asset comes back online, select the channels below and click &apos;Request For
                                            Later&apos;.
                                        </div>
                                    </>
                                )}
                                buttonLabel="Request for later"
                                channels={canViewHistoricVideo ? channels : []}
                                onClick={this.requestCacheAndTrimVideos} />
                        )
                        : null}
                    {/* Streaming videos now */}
                    {streamingVideos && searchedSingleVideoChannels.length > 0
                        ? (
                            <Spinner loading={!videoStreamsReady} minHeight={200}>
                                <VideoPlayers refs={this.streamingVideosRefs} videos={searchedSingleVideoChannels} onReady={this.onReady.bind(this)} onRemoved={this.onRemoved.bind(this)} minHeight={348} />
                            </Spinner>
                        )
                        : null}
                </Spinner>
            );
        }

        if ((canViewHistoricVideo || parent === 'sharedView') && videoMode === 'cached') {
            const nonCachedChannels = [];

            for (let i = 0; i < channels.length; i++) {
                const channel = channels[i];
                let alreadyCached = false;
                for (let j = 0; j < cachedVideos.length; j++) {
                    const cachedVideo = cachedVideos[j] ? cachedVideos[j][0] : null;
                    if (cachedVideo && channel.channel == cachedVideo.channel) {
                        alreadyCached = true;
                        break;
                    }
                }
                if (!alreadyCached) {
                    nonCachedChannels.push(channel);
                }
            }

            return (
                <Spinner loading={isFetchingVideoUrls}>
                    {cachedVideos ? (
                        <>
                            <VideoPlayers refs={this.cachedVideosRefs} videos={cachedVideos} isFlv={false} />
                        </>
                    ) : null}
                    {parent !== 'sharedView' && nonCachedChannels.length > 0 ? (
                        <VideoSelection
                            allowActions={canViewHistoricVideo && allowActions}
                            className="extra-height"
                            parent={this}
                            content={(
                                <>
                                    <div>To download this footage automatically when the asset comes back online, select the channels below and click &apos;Request For
                                        Later&apos;.
                                    </div>
                                </>
                            )}
                            buttonLabel="Request for later"
                            channels={canViewHistoricVideo ? nonCachedChannels : []}
                            onClick={this.requestCacheAndTrimVideos} />
                    ) : null}
                </Spinner>
            );
        }

        return null;
    };
    const videoSidebar = () => {
        const { live_video: canViewLiveVideo, historic_video_downloading: canViewHistoricVideo } = permissions;
        const defaultTab = !canViewLiveVideo || cachedVideos.length > 0 ? 'cached' : 'streaming';
        const adjustableHeight = videoMode === 'streaming' && !streamingVideos && +dvrOnline === 0;

        if (!videoSidePanelPermission) {
            return null;
        }

        if (!showDownloadIframe) {
            return null;
        }

        // the only instance this should be disabled is when user can choose videoMode and there are no cached videos
        const cachedButtonDisabled = canViewLiveVideo && canViewHistoricVideo && cachedVideos.length === 0;
        return (
            <Col xs={24} md={14} style={{ paddingTop: '145px' }}>
                {(selectedEvent && selectedEvent.dvrDetails && Object.keys(selectedEvent.dvrDetails).length > 0) || showStreamingSectionOnLoad
                    ? (
                        <>
                            <Row style={{ marginBottom: '16px' }}>
                                <Col span={24}>
                                    <div style={{
                                        textAlign: 'right',
                                        marginBottom: '5px',
                                    }}>
                                        <Row>
                                            <Col 
                                                xs={24}
                                            >
                                                <span style={{ float: 'left', height: '32px' }}>
                                                    <Radio.Group
                                                        defaultValue={defaultTab}
                                                        buttonStyle="solid"
                                                        onChange={(e) => {
                                                            const state = {};
                                                            state.videoMode = e.target.value;
                                                            state.streamingVideos = false;
                                                            state.selectedVideoChannels = [];
                                                            this.setState(state);
                                                            if (this.videoTimer != null) {
                                                                this.videoTimer = clearTimeout(this.videoTimer);
                                                            }
                                                        }}
                                                    >
                                                        {canViewLiveVideo && (
                                                            <Radio.Button value="streaming">Streaming</Radio.Button>
                                                        )}
                                                        {canViewHistoricVideo && (
                                                            <Radio.Button
                                                                value="cached"
                                                                disabled={cachedButtonDisabled}
                                                            >
                                                                Downloaded
                                                            </Radio.Button>
                                                        )}
                                                    </Radio.Group>
                                                </span>
                                                <span style={{ float: 'right', height: '32px' }}>
                                                    {showDownloadIframe && (
                                                        <Button
                                                            type="primary"
                                                            onClick={(e) => {
                                                                if (shareReportType === 'cache') {
                                                                    generateCacheReport();
                                                                } else if (shareReportType === 'video') {
                                                                    generateVideoReport();
                                                                } else {
                                                                    generateEventReport();
                                                                }
                                                                this.setState({ shareModalIsOpen: true });
                                                            }}
                                                        >
                                                            Share
                                                        </Button>
                                                    )}
                                                    {canViewHistoricVideo && allowActions && isEmpty(cachedVideos) && channels.length > 0 && !hasFailedCached
                                                        ? (
                                                            <Button
                                                                type="primary"
                                                                onClick={this.requestCacheAndTrimVideos}
                                                                className="btn"
                                                                style={{ marginLeft: '16px' }}
                                                            >
                                                                Download
                                                            </Button>
                                                        )
                                                        : null}
                                                    {videoMode === 'cached' && (
                                                        <ExportVideoStatus
                                                            isShareView={parent === 'sharedView'}
                                                            requestExportCacheVideo={this.requestExportCacheVideo}
                                                            exportedCacheVideo={exportedCacheVideo}
                                                            checkStatus={this.requestExportCacheVideoStatus.bind(this)}
                                                            channels={channels}
                                                            pendingVideoes={discoveredVideos}
                                                        />
                                                    )}
                                                </span>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <div className={`video-sidebar ${adjustableHeight ? 'extra-height' : ''}`}>
                                {videoContent()}
                            </div>
                        </>
                    )
                    : null}
            </Col>
        );
    };
    let actualShowTimingPresetsFooter = showTimingPresetsFooter;
    if (actualShowTimingPresetsFooter === undefined) {
        actualShowTimingPresetsFooter = true;
    }

    return (
        <div 
            className={showDownloadIframe ? 'video-detail-view' : 'video-detail-view video-detail-view-pdf'} 
            ref={this.pdfDocumentRef}
            style={{ 
                paddingRight: 0, 
                paddingLeft: 0,
            }}
        >
            {showDownloadIframe
                ? null
                : (
                    <ReactToPdf
                        x={0}
                        y={0}
                        targetRef={this.pdfDocumentRef}
                        filename={`event_report_${dayjs().format('YYYY_MM_DD_HH_MM_SS')}.pdf`}
                        scale={1}
                        options={{
                            orientation: 'l',
                            unit: 'px',
                            format: [1500, 850],
                        }}>
                        {({ toPdf }) => (
                            <Button
                                id="download-pdf-button"
                                type="primary"
                                className="btn ml-2"
                                onClick={(e) => { this.renderPdf(toPdf); }}>
                                <Spinner loading={false}>
                                    <LegacyIcon name="share2" />
                                    <span>download pdf report</span>
                                </Spinner>
                            </Button>
                        )}
                    </ReactToPdf>
                )
            }
            <Row gutter={16}>
                <Col
                    xs={24}
                    md={showDownloadIframe && videoSidePanelPermission ? mapWidthSpan : 24}
                >
                    <Row 
                        className="map-container"
                        style={{
                                minHeight: 'calc(100vh - 160) !important',
                                height: 'calc(100vh - 160) !important',
                                maxHeight: 'calc(100vh - 160) !important',
                            }}
                    >
                        <Col span={24} style={{ height: '100%' }}>
                            <div style={{ height: '8px' }} />
                            <Map
                                ref={this.googleMapAccess}
                                allowMultipleRangeSlider
                                sliderRangeMaxValue={sliderRangeMaxValue}
                                sliderRangeMinValue={sliderRangeMinValue}
                                markerOnMouseEnter={(marker) => {
                                    setMarkerPopoverToLoading(this);
                                    requestMarkerDetails(marker, this);
                                }}
                                markerPopover={markerPopover}
                                highlightSlider={highlightSlider}
                                mapDate={dayjs().subtract('1', 'days').format('DD/MM/YYYY')}
                                apiKey={GOOGLE_MAP_API_KEY}
                                mapToolBarButtons={mapToolBarButtons}
                                sliderStep={1}
                                sliderValue={parseInt(sliderValue, 10)}
                                sliderMinValue={selectedEvent?.startInterval}
                                sliderMaxValue={selectedEvent?.endInterval}
                                sliderValueUnit="seconds"
                                hideDatePicker
                                onSliderRangeChange={this.onSliderRangeChange}
                                assets={assets}
                                showToolbar={showDownloadIframe}
                                toolbarLoading={!selectedEvent}
                                path={mappedDevicePath}
                                onAutoPlay={this.handleResume}
                                onPause={this.handlePause}
                                allowStreetView={false}
                                showFindCenterButton={false}
                                forwardCallback={this.handleForward}
                                rewindCallback={this.handleRewind}
                                increaseOptionCallback={this.handleIncreaseOptionCallback}
                                resetCallback={this.handleReset}
                                showResetBtn={showResetBtn}
                                showTimingPresetsFooter={actualShowTimingPresetsFooter}
                                overrideToolbarWidth={parent === 'sharedView' ? (window.screen.width - 64) : (sidebarIsOpen ? window.screen.width - 80 - 360 - 32 : window.screen.width - 80 - 64 - 24)}
                                
                            />
                        </Col>
                    </Row>
                    {!hasDVR && (
                        <p style={{
                            textAlign: 'right',
                            paddingTop: 10,
                            paddingRight: 10,
                        }}>
                            No DVR is connected to the asset.
                        </p>
                    )}
                </Col>
                {videoSidebar()}
            </Row>
            <Modal
                title={shareReportType === 'event' ? "Share Event" : "Share Video"}
                open={shareModalIsOpen}
                onOk={() => { this.setState({ shareModalIsOpen: false }); }}
                okText="Done"
                cancelButtonProps={{ style: { display: 'none' }}}
                onCancel={() => { this.setState({ shareModalIsOpen: false }); }}
            >
                <br />
                {eventsIsFetching ? (
                    <div style={{ height: 100 }}>
                        <Spinner loading minHeight={100} />
                    </div>
                ) : (
                    <Row>
                        <Col xs={6}>
                            <div style={{ textAlign: 'right', fontWeight: 600, color: 'var(--cool-gray-60)' }}>URL:&ensp;&ensp;</div>
                            <div style={{ textAlign: 'right', fontWeight: 600, color: 'var(--cool-gray-60)' }}>Password:&ensp;&ensp;</div>
                        </Col>
                        <Col xs={'auto'}>
                            <div ref={urlText}>{shareLink}</div>
                            <div ref={passwordText}>{share?.password}</div>
                        </Col>
                        <Col xs={2} style={{ textAlign: 'center' }}>
                            <div>
                                <Tooltip title='Copy URL'>
                                    <CopyOutlined onClick={() => {
                                        navigator.clipboard.writeText(urlText.current.textContent);
                                        message.success('Copied to clipboard');
                                    }} />
                                </Tooltip>
                            </div>
                            <div style={{ marginBottom: 8 }}>
                                <Tooltip title='Copy Password'>
                                    <CopyOutlined onClick={() => {
                                        navigator.clipboard.writeText(passwordText.current.textContent);
                                        message.success('Copied to clipboard');
                                    }} />
                                </Tooltip>
                            </div>
                        </Col>
                    </Row>
                )}
            </Modal>
        </div>
    );
}
